import React, { FC, useCallback } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/subscription-cancel/cancel.module.css';

export const Cancel: FC<{ subscriptionCancelFunc: () => void }> = ({ subscriptionCancelFunc }) => {
  const btnClickHandler = useCallback(() => {
    subscriptionCancelFunc();
  }, [subscriptionCancelFunc]);

  return (
    <>
      <div className={classes.mypage_subsc_cancel_confirm}>
        <h2>毎月お届けプランの解約</h2>
        <div>(仮)泣いているジャコミーノ</div>
        <p>
          登録されている設定は削除されますが、
          <br />
          毎月お届けプランはまたいつでも再開できます。
          <br />
          またのご利用お待ちしております！
        </p>
        <div className={classes.mypage_subsc_cancel_buttons}>
          <button onClick={btnClickHandler}>解約する</button>
          <Link to="/">もどる</Link>
        </div>
      </div>
    </>
  );
};
